import React, { useMemo } from "react";
import styles from "./ExcursionActivityLevel.module.scss";
import commonStyles from "../commons.module.scss";
import clsx from "clsx";

export type ExcursionActivityLevelProps = {
  title: string;
  iconStep: number;
  label: string | undefined;
  titleClassName?: string;
};

export const ExcursionActivityLevel: React.FC<
  React.PropsWithChildren<ExcursionActivityLevelProps>
> = ({ title, label, iconStep = 0, titleClassName = undefined }) => {
  const svgIcon = useMemo(() => buildSVGIcons(iconStep), [iconStep]);

  return (
    <div className={commonStyles.boxContainer}>
      <div className={clsx(commonStyles.boxTitle, titleClassName)}>{title}</div>
      <div className={styles.icons}>{svgIcon}</div>
      <div className={commonStyles.boxLabel}>{label}</div>
    </div>
  );
};

const buildSVGIcons = (iconStep: number) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="73"
    height="14"
    viewBox="0 0 73 14"
    fill="none"
  >
    {Array(4)
      .fill(0)
      .map((_, value) => {
        const cxOffset = value * 20 + 6;
        if (value < iconStep) {
          return (
            <circle key={value} cx={cxOffset} cy="6.75" r="6" fill="#303030" />
          );
        }

        return (
          <circle key={value} cx={cxOffset} cy="6.75" r="6" stroke="#303030" />
        );
      })}
  </svg>
);

export default ExcursionActivityLevel;
